<template>
  <div class="manual-page">
    <Toolbar title-tag="h1">
      <template #title>Как играть</template>
    </Toolbar>
    <ContentBlock class="pt-5">
      <div class="manual-page__steps">
        <div
          v-for="(step, index) in steps"
          :key="index"
          class="manual-page__column"
        >
          <ManualStep :item="step" />
        </div>
      </div>
    </ContentBlock>
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar/";
import ManualStep from "./ManualStep";

export default {
  name: "ManualPage",
  components: {
    Toolbar,
    ManualStep
  },
  breadcrumb: {
    title: "Как играть?",
    to: "/manual"
  },
  data: () => ({
    steps: [
      {
        title: "Формат турнира «4 на 4»",
        src: require(`@/assets/images/steps/step_1.webp`),
        srcFallback: require(`@/assets/images/steps/step_1.png`)
      },
      {
        title: "Без вратарей",
        src: require(`@/assets/images/steps/step_2.webp`),
        srcFallback: require(`@/assets/images/steps/step_2.png`)
      },
      {
        title: "Каждый период начинается с вбрасывания шайбы",
        src: require(`@/assets/images/steps/step_3.webp`),
        srcFallback: require(`@/assets/images/steps/step_3.png`)
      },
      {
        title: "Два периода по 15 минут",
        src: require(`@/assets/images/steps/step_4.webp`),
        srcFallback: require(`@/assets/images/steps/step_4.png`)
      },
      {
        title: "«Щелчки» запрещены",
        src: require(`@/assets/images/steps/step_5.webp`),
        srcFallback: require(`@/assets/images/steps/step_5.png`)
      },
      {
        title: "Силовые приемы запрещены",
        src: require(`@/assets/images/steps/step_6.webp`),
        srcFallback: require(`@/assets/images/steps/step_6.png`)
      },
      {
        title: "Пробросы и оффсайды не регистрируются",
        src: require(`@/assets/images/steps/step_7.webp`),
        srcFallback: require(`@/assets/images/steps/step_7.png`)
      }
    ]
  })
};
</script>

<style lang="scss">
.manual-page {
  &__steps {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  &__column {
    padding: 10px 25px;
  }
}
</style>
